import {Stack, Typography} from "@mui/material";
import * as React from "react";
import {useNavigate} from "react-router-dom";

const RequestCard = (props) =>
{
    const navigate = useNavigate();

    function onView()
    {
        navigate("../networks/" + props.networkUID + "/requests/" + props.entry.requestUID);
    }

    return (
        <Stack direction="column" padding={1} spacing={1} alignItems="center" backgroundColor={'#141C21'} onClick={onView} borderRadius={3} sx={{width: 200, height: 200, cursor: "pointer"}}>
            <img src="/icons/request.png" width={64} height={64}/>
            <Stack direction="column" padding={1} alignItems="flex-start">
                <Typography>{props.entry.display}</Typography>
                <Typography variant="caption">{props.entry.requestUID}</Typography>
            </Stack>
        </Stack>
    )
}
export default RequestCard;
